<button class="back-button" mat-button (click)="handleBackButton()">
  <mat-icon>arrow_back</mat-icon>
  <span i18n>Vorige pagina</span>
</button>
